import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./statusCardList.module.scss";

interface StatusItem {
  count: number;
  label: string;
  color: string;
}

interface StatusCardListProps {
  title?: string;
  data?: StatusItem[];
}

const StatusCardList: React.FC<StatusCardListProps> = ({
  title = "PR by Status",
  data = [],
}) => {
  if (!data || data.length === 0) {
    return (
      <Box className={styles.container}>
        {title && (
          <Box className={styles.header}>
            <Typography variant="h6" className={styles.title}>
              {title}
            </Typography>
          </Box>
        )}
        <Box
          className={styles.cardsContainer}
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight={150}
        >
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={styles.container}>
      {title && (
        <Box className={styles.header}>
          <Typography variant="h6" className={styles.title}>
            {title}
          </Typography>
        </Box>
      )}

      <Box className={styles.cardsContainer}>
        {data.map((item, index) => (
          <Box
            key={index}
            className={styles.statusCard}
            sx={{
              borderColor: item.color,
            }}
          >
            <Box
              className={styles.statusIndicator}
              sx={{ backgroundColor: item.color }}
            />
            <Typography variant="h4" className={styles.count}>
              {item.count}
            </Typography>
            <Typography variant="body2" className={styles.label}>
              {item.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StatusCardList;
